$( document ).ready(function() {
//  $.get("//ipinfo.io?token=3c3f05ee166d56", function(e){
// var locat_area;
//  locat_area =e.country;
//  console.log(locat_area);
//   if (locat_area == 'IN'){
//     console.log("India"); 
//    }
//    else {
//    window.location.replace("https://campussutra.ca/");
//    }
// },"jsonp"); 
   setTimeout(function() {
$(".top-bar .flex-item").show();
  }, 1000);
 if ($(window).width() > 767) {
   $(".custom_mobile_des").empty();
}
 if ($('#404-not-found .empty-page-content')[0]) {
  window.location.replace("https://campussutra.com/");
} 
 // Size Select in PDP
var sel_size = $("label.pos-Size").attr("data-value-new");
var sel_val = $("label.pos-Size").val();
if( sel_size != sel_val){
  $(".product-action button").addClass("active-size-select");
   $("a.Select-size-dummy").addClass("active");
   // $(".stickyCart").addClass("overlay-sel");
   $(".sel_sticky").addClass("active-sel");
   $(".stickyCart form").addClass("select_op");
  $("a.stick_pl_btn").addClass("active_st");
   $(".new_thi_div").addClass('active_new_d');
   $(".sel_stic_btn").css("display","none");
   $(".selectedst_view").addClass("active_stoper");
  }
   $(document).on('click', '.show-Size .swatch-element', function () {
  $(".product-action button").removeClass("active-size-select");
      $("a.view_your_cart_dummy").removeClass('new_view_cart_show'); 
      $("a.image_add_to_btn").addClass("act_img_btn");
      $('.product-form__cart-submit').removeClass('new_myn');
       $('.quickshop-cart').removeClass('new_myn');
     $("a.Select-size-dummy").removeClass("active");
      $(".val--Size").show();
     $("a.Select-size-dummy_2").addClass("active_qui");
        $(".sel_qui").addClass("act_se");
     $(".show-Size .sel_msg").removeClass("active_sz");
     $(".show-SIZE .sel_msg").removeClass("active_sz");
    $(".show-size .sel_msg").removeClass("active_sz");
   });
    $(document).on('click', 'li.vrOpt', function () {
      $("a.stick_pl_btn").removeClass("active_st");
       $(".new_thi_div").removeClass('active_new_d');
        $(".sel_stic_btn").css("display","block");
    }); 
  $(document).on('click', 'strong.button_seemore', function () {
       $(this).addClass("active_seemore");
       $(".seemore_view").show();
       $("strong.button_lessmore").addClass("active_lessmore");
    });
     $(document).on('click', 'strong.button_lessmore', function () {
      $(this).removeClass("active_lessmore");
      $(".seemore_view").hide();
     $(this).parents(".pre_paidtext").find("strong.button_seemore").removeClass("active_seemore");
    });
  var sel_size_1 = $("label.pos-SIZE").attr("data-value-new");
var sel_val_1 = $("label.pos-SIZE").val();
if( sel_size_1 != sel_val_1){
  $(".product-action button").addClass("active-size-select");
   $("a.Select-size-dummy").addClass("active"); $("a.Select-size-dummy").addClass("active");
   // $(".stickyCart").addClass("overlay-sel");
   $(".sel_sticky").addClass("active-sel");
   $(".stickyCart form").addClass("select_op");
  $("a.stick_pl_btn").addClass("active_st");
   $(".new_thi_div").addClass('active_new_d');
   $(".sel_stic_btn").css("display","none");
   $(".selectedst_view").addClass("active_stoper");
  }
   $(document).on('click', '.show-SIZE .swatch-element', function () {
  $(".product-action button").removeClass("active-size-select");
     $("a.Select-size-dummy").removeClass("active");
      $("a.image_add_to_btn").addClass("act_img_btn");
      $("a.view_your_cart_dummy").removeClass('new_view_cart_show'); 
      $('.product-form__cart-submit').removeClass('new_myn');
      $('.quickshop-cart').removeClass('new_myn');
           $(".val--Size").show();
     $("a.Select-size-dummy_2").addClass("active_qui");
        $(".sel_qui").addClass("act_se");
      $(".show-Size .sel_msg").removeClass("active_sz");
     $(".show-SIZE .sel_msg").removeClass("active_sz");
    $(".show-size .sel_msg").removeClass("active_sz");
   });
    $(document).on('click', 'li.vrOpt', function () {
      $("a.stick_pl_btn").removeClass("active_st");
        $(".sel_stic_btn").css("display","block");
    }); 
   // Size Select in PDP
  // Size Select Msg In 
  $(document).on('click', '.sel_btn_click', function () {
    $(".show-Size .sel_msg").addClass("active_sz");
     $(".show-SIZE .sel_msg").addClass("active_sz");
    $(".show-size .sel_msg").addClass("active_sz");
    $(".selectedst_view").addClass("active_hy");
     $(".show-Size").addClass("face_size");
      $(".show-SIZE").addClass("face_size");
      $(".show-size").addClass("face_size");
});
  $(document).on('click', '.show-Size .swatch-element:not(.soldout)', function () {
     $("a.stick_pl_btn").removeClass("active_st");
     $(".new_thi_div").removeClass('active_new_d');
        $(".sel_stic_btn").css("display","block");
  var iuy = $(this).attr('data-inv');
     $('ul li.vrOpt').each(function(){
		if(iuy == $(this).attr('data-val')){
   $(this).trigger('click'); 
        }
  });
  });
   $(document).on('click', '.stick_pl_btn.sel_btn_click', function () {
      $(".color_check_happened").removeClass('act_color');  
      var ghyuj= $(".show-Size").html();
     $(".add_size_on_click_html").html(ghyuj);
      $(".add_size_on_click").addClass('act_op');
   });
   $(document).on('click', '.add_size_on_click_html .swatch-element', function () {
          $('.add_size_on_click_html .swatch-element').removeClass("act_swa");
     $(this).addClass("act_swa");
      $(".done_cli").addClass('active_rt');
   });
   // $(document).on('click', '.done_cli', function () {
   //    $("a.image_add_to_btn").removeClass("act_img_btn");
   //    $(".add_size_on_click").removeClass('act_op');
   // });
   $(document).on('click', '.done_cli.active_rt', function () {
       $(".add_size_on_click").removeClass('act_op');
      $(".btn.sel_stic_btn").trigger('click'); 
   });
  $(document).on('click', '.image_add_to_btn', function () {
         $(this).removeClass('act_img_btn');
       $(".add_size_on_click").removeClass('act_op');
      $(".btn.sel_stic_btn").trigger('click'); 
   });
 $(document).on('click', '.swatch-element.soldout', function () {
    $(".image_add_to_btn").removeClass('act_img_btn');
 });
   $(document).on('click', '.close_div_sel', function () {
      $("a.image_add_to_btn").removeClass("act_img_btn");
      $(".val--Size").hide();
      $(".done_cli").removeClass('active_rt');
       $(".add_size_on_click").removeClass('act_op');
      $(".stick_pl_btn").addClass('active_st');
      $(".new_thi_div").addClass('active_new_d');
      $("a.Select-size-dummy").addClass("active");
     $('.product-form__cart-submit').addClass('new_myn');
    $(".sel_stic_btn.active_pt").hide();
     $(".swatch-element .swatchInput").prop("checked", false);
   });
    $(document).on('click touchend', '.product-form__cart-submit', function(i){
       if (i.preventDefault(), "disabled" != $(this).attr("disabled")){
    $('.product-form__cart-submit').addClass('new_myn');
         $(".done_cli").removeClass('active_rt');
          $(".val--Size").hide();
          $(".swatch-element .swatchInput").prop("checked", false);
          $("a.Select-size-dummy").addClass("active");
          $(".image_add_to_btn").removeClass('act_img_btn');
        $("a.stick_pl_btn").addClass("active_st");
          $(".new_thi_div").addClass('active_new_d');
         $(".sel_stic_btn.active_pt").addClass("new_myn");
          $(".add_size_on_click").removeClass('act_op');
       }
   });
    $(document).on('click', '.quickshop-cart', function(i){
             $(this).addClass('new_myn');
            $("a.view_your_cart_dummy").addClass('new_view_cart_show');  
            
});
   $(document).on('click', 'a.view_your_cart_dummy', function () {
     $("a.header-cart").trigger('click');
   });
 
 $(document).on('click', '.size_chart_pdp_link', function () {
    $("a.sizelink").trigger('click');
 });
   $(document).on('click', '.color_upper_pdpimage', function () {
      $(".add_size_on_click").removeClass('act_op');
    $(" .color_check_happened").addClass('act_color');  
      var ghyujcolor= $(".show-Color").html();
     $(".sho_color_panel").html(ghyujcolor);
   });
  $(document).on('click', '.close_div_sel_color', function () {
    $(" .color_check_happened").removeClass('act_color');  
   });
  function copyToClipboard(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
}
   var addrsField = $('.pdp_disc_text_cust_include_couponCode.mobile_click');
$('.coupon_code_pdp.mobile_click').click(function() {
        copyToClipboard('.pdp_disc_text_cust_include_couponCode.mobile_click');
        addrsField.addClass('flashBG')
          .delay('1000').queue(function(){
            addrsField.removeClass('flashBG').dequeue();
        });
    });
 var addrsField2 = $('.pdp_disc_text_cust_include_couponCode.desktop_click');
$('.coupon_code_pdp.desktop_click').click(function() {
        copyToClipboard('.pdp_disc_text_cust_include_couponCode.desktop_click');
        addrsField2.addClass('flashBG')
          .delay('1000').queue(function(){
            addrsField2.removeClass('flashBG').dequeue();
        });
    });
// Video Highlights
$('.video_highlights_pdp_header').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: true,
    arrows: true,
    dots: false,
    centerMode: true,
});
// Video Highlights
//   function check_items() {
//     var prod_ids = $(".quarec_text").attr("data-proid");
//    $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         cache: false,
//         dataType: 'json',
//         success: function(cart) {
//            var items=cart['items'];
//           for (let i = 0; i < items.length; i++) {
//             var varid = items[i]['product_id'];
//               var qty = items[i]['quantity'];
//             if (varid == prod_ids) {
//               var qty = items[i]['quantity'];
//                $(".quarec_text span").append(qty);
//                 $(".quarec_text").show();
              
//             }
// }
         
         
//         }
//     });
//   }
//   check_items();
  // Size Select Msg In 
 $(document).on('click', 'strong.button_seemore', function () {
       $(this).addClass("active_seemore");
       $(".seemore_view").show();
       $("strong.button_lessmore").addClass("active_lessmore");
    });
     $(document).on('click', 'strong.button_lessmore', function () {
      $(this).removeClass("active_lessmore");
      $(".seemore_view").hide();
     $(this).parents(".pre_paidtext").find("strong.button_seemore").removeClass("active_seemore");
    });
// Show title in header
var btn_title = $('.nert_he_ba');

$(window).scroll(function() {
  if ($(window).scrollTop() > 700) {
    btn_title.addClass('show');
  } else {
    btn_title.removeClass('show');
  }
});
// Show title in header 
  $(document).on('click', '.feature-pdp-returnpolicy', function () {
   $(this).toggleClass("active");
   $(".feature-pdp-returnpolicyContent").toggleClass("active");
  });
   $(document).on('click', '.feature-pdp-shippingtext', function () {
   $(this).toggleClass("active");
   $(".cod_check_status").toggleClass("active");
  });
 // Collection Top Filter
  var fil_option=$("ul.cust_fil_top_content").attr("data-filt");
  if (fil_option == "Categories"){
   $(".cust_fil_top_content.Categories").css("display","flex");
  }
  else if (fil_option == "Neck"){
     $(".cust_fil_top_content.Neck").css("display","flex");
  }
  else if (fil_option == "Sleeve"){
     $(".cust_fil_top_content.Sleeve").css("display","flex");
  }
  else if (fil_option == "Length"){
     $(".cust_fil_top_content.Length").css("display","flex");
  }
  else {
     $(".cust_fil_top_content.Pattern").css("display","flex");
  }
   $(document).on('click', '.filter_cust_name label', function () {
      $(".filter_cust_name label").toggleClass("active_filter_ev");
     var tex_act_fil = $.trim($(this).text());
     var tex_act_fil_split = tex_act_fil.split(" ")[0];
      $(this).toggleClass("active");
      $("ul.widget-content").parents(".sidebar_widget").find("."+tex_act_fil_split).trigger("click");
     });
    // Collection Top Filter
// Collection Slider
//   function collSliderInit() { 
//            $('.collection_new_slider').slick({
//         });
//   }
//    collSliderInit();
//  $(document).on('click', '.coll_header_filter, .sidebar_widget', function () {
//  setTimeout(function() {
//   collSliderInit();
//     }, 4000);
//  });
//   $(document).on('click', '#SortBySt', function () {
//  setTimeout(function() {
//   collSliderInit();
//     }, 5000);
//  });
//  $(document).on('click', '.template-collection', function () {
//   collSliderInit();
//  });
// $(document).on('click', '.active-facets', function () {
//  setTimeout(function() {
//   collSliderInit();
//     }, 5000);
//  });
 // Collection Slider
});
 